export enum TipoContaContabil {
    A = 1,
    S = 2
}
